import { action, makeObservable, observable } from "mobx";
import { makePersistable } from "mobx-persist-store";
import localForage from "localforage";
import type { MetadataResponse } from "@/types/api";

export class MetaDataStore {
  isHydrated = false;
  metadata: MetadataResponse | null = null;

  private persistPromise: Promise<void> | null = null;

  constructor() {
    makeObservable(this, {
      isHydrated: observable,
      metadata: observable,
      setIsHydrated: action,
      setMetadata: action
    });
  }

  async makePersist(): Promise<void> {
    if (this.persistPromise) {
      return this.persistPromise;
    }

    this.persistPromise = makePersistable(
      this,
      {
        name: this.constructor.name,
        properties: ["metadata"],
        storage: localForage,
        expireIn: 1000 * 60 * 60 * 24, // 24 hours
        removeOnExpiration: true,
        stringify: true,
        debugMode: false
      },
      { delay: 200, fireImmediately: true }
    ).then(
      action(() => {
        this.setIsHydrated();
      })
    );

    return this.persistPromise;
  }

  setIsHydrated() {
    this.isHydrated = true;
  }

  setMetadata(metadata: MetadataResponse) {
    this.metadata = metadata;
  }
}
